import { createReducer } from './create';

const initialState = {
    selected_package: null,
};

export default createReducer(initialState, {
    ['APP/CLEAR']: (state, payload) => {
        return initialState;
    },
    ['APP/SOFT_CLEAR']: (state, payload) => {
        return Object.assign({}, initialState, {
            selected_package: state.selected_package,
        });
    },
    ['APP/GO_TO_STEP_1']: state => {
        return {
            ...state,
            selected_package: null,
        };
    },
    ['PACKAGES/SELECT']: (state, payload) => {
        return Object.assign({}, state, {
            selected_package: payload.package,
        });
    },
});
